import React from 'react';

import {
  Grid,
} from '@mui/material';
import { useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';

import SignIn from '../../components/SignIn';
import logo from '../../images/logo.png';
import { cognitoApi } from '../../services/cognitoApi';

import {
  Container, Logo, RootContainer, Title, TitleContainer,
} from './index.styles';

const SignInPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [searchParams] = useSearchParams();

  return (
    <RootContainer>
      <Grid
        container
        rowSpacing={{
          xs: 4, md: 2,
        }}
        columnSpacing={2}
      >
        <Grid item xs={12}>
          <Container>
            <TitleContainer href="/">
              <Logo src={logo} alt="logo" />
              <Title variant="h4">Cognito Online</Title>
            </TitleContainer>
          </Container>
        </Grid>
        <Grid item xs={12}>
          <Container>
            <SignIn
              onAuthenticate={() => {
                // Reset API cache on login
                dispatch(cognitoApi.util.resetApiState());

                // Navigate to the redirect source, or to the home page
                // if the source is undefined
                navigate(searchParams.get('redirect') || '/');
              }}
              onUnconfirmedSignIn={(email: string, password:string) => {
                navigate('/signup?confirm=false', {
                  state: {
                    email,
                    password,
                  },
                });
              }}
            />
          </Container>
        </Grid>
      </Grid>
    </RootContainer>
  );
};

export default SignInPage;
